<template>
  <div class="chat-wrapper">
    <div id="chat-container"></div>
  </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";
import { aiApi } from "../../api/api-director";
let chatClient = null;
export default {
  data() {
    return {
      // 不将chatClient存储在data中，避免Vue的响应式系统处理
    };
  },
  // 使用普通属性存储chatClient
  computed: {
    ...mapState(["userInfo", "headers"]),
  },
  props: {
    id: {
      type: String,
      default: '',
    },
  },
  watch: {
    id: {
      handler(newVal, oldVal) {
        if (newVal) {
          if (chatClient) {
            chatClient.destroy();
            chatClient = null;
          }
          this.initChatContainer();
        }
      },
      deep: true,
    }
  },
  created() {
    this.initChatContainer();
  },
  beforeDestroy() {
    if (chatClient) {
      chatClient.destroy();
      chatClient = null;
    }
  },
  methods: {
    initChatContainer() {
      if (!this.userInfo) return;
      axios
        .get(aiApi.main + "/aiweb/getToken.htm?user_id=" + this.userInfo.id)
        .then((response) => {
          // 处理成功响应
          this.initChat(response.data.data);
        })
        .catch(function(error) {
          // 处理错误响应
          console.error(error);
        });
    },
    initChat(token) {
      console.log(token);
      //地址栏route获取bot_id
      let bot_id = this.id
      chatClient = new CozeWebSDK.WebChatClient({
        /**
         * Agent or app settings
         * for agent
         * @param config.bot_id - Agent ID.
         * for app
         * @param config.type - To integrate a Coze app, you must set the value to app.
         * @param config.isIframe - Whether to use the iframe method to open the chat box
         * @param config.appInfo.appId - AI app ID.
         * @param config.appInfo.workflowId - Workflow or chatflow ID.
         */
        config: {
          type: "bot",
          bot_id: bot_id,
          isIframe: false,
          botInfo: {
            parameters: {
              user_id: String(this.userInfo.id),
              nickname: this.userInfo.nickName,
              school_id: String(this.userInfo.school_id) ,
              bot_id: String(bot_id) ,
            },
          },
        },
        stream: true,
        /**
         * The auth property is used to configure the authentication method.
         * @param type - Authentication method, default type is 'unauth', which means no authentication is required; it is recommended to set it to 'token', which means authentication is done through PAT (Personal Access Token) or OAuth.
         * @param token - When the type is set to 'token', you need to configure the PAT (Personal Access Token) or OAuth access key.
         * @param onRefreshToken - When the access key expires, a new key can be set as needed.
         */
        auth: {
          type: "token",
          token: token,
          onRefreshToken: async () => token,
        },
        /**
         * The userInfo parameter is used to set the display of agent user information in the chat box.
         * @param userInfo.id - ID of the agent user.
         * @param userInfo.url - URL address of the user's avatar.
         * @param userInfo.nickname - Nickname of the agent user.
         */
        userInfo: {
          id: String(this.userInfo.id),
          url:
            this.userInfo && this.userInfo.head_img
              ? this.userInfo.head_img
              : "../../assets/person.png",
        },
        ui: {
          /**
           * The ui.base parameter is used to add the overall UI effect of the chat window.
           * @param base.icon - Application icon URL.
           * @param base.layout - Layout style of the agent chat box window, which can be set as 'pc' or'mobile'.
           * @param base.lang - System language of the agent, which can be set as 'en' or 'zh-CN'.
           * @param base.zIndex - The z-index of the chat box.
           */
          base: {
            icon:
              require("@/assets/ai/ml.jpg"),
            layout: "pc",
            lang: "zh-CN",
            borderRadius: 10,
            zIndex: 100,
            round: 20
          },
          /**
           * Controls whether to display the top title bar and the close button
           * @param header.isShow - Whether to display the top title bar.
           * @param header.isNeedClose - Whether to display the close button.
           */
          header: {
            isShow: true,
            isNeedClose: true,
          },
          /**
           * Controls whether to display the floating ball at the bottom right corner of the page.
           */
          asstBtn: {
            isNeed: false,
          },
          /**
           * The ui.footer parameter is used to add the footer of the chat window.
           * @param footer.isShow - Whether to display the bottom copy module.
           * @param footer.expressionText - The text information displayed at the bottom.
           * @param footer.linkvars - The link copy and link address in the footer.
           */
          footer: {
            isShow: false,
            expressionText: "来自成长册",
          },
          //输入框默认提示语
          conversations: {
            isNeed: false,
          },
          /**
           * Control the UI and basic capabilities of the chat box.
           * @param chatBot.title - The title of the chatbox
           * @param chatBot.uploadable - Whether file uploading is supported.
           * @param chatBot.width - The width of the agent window on PC is measured in px, default is 460.
           * @param chatBot.el - Container for setting the placement of the chat box (Element).
           */
          chatBot: {
            title: "小米粒助手",
            uploadable: true,
            width: 800,
          },
        },
      });

      setTimeout(() => {
        chatClient.showChatBot();
      }, 300);
    },
  },
};
</script>
<style lang="scss" scoped>
#chat-container {
  width: 800px;
  margin: 0 auto;
}


.chat-wrapper {
  position: fixed;
}
</style>
